var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgInfo = function SvgInfo(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-16": 13,
    "data-width-24": 20,
    "data-width-32": 26,
    viewBox: "0 0 13 13",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.5 13A6.5 6.5 0 1 1 13 6.5 6.506 6.506 0 0 1 6.5 13m0-12A5.5 5.5 0 1 0 12 6.5 5.507 5.507 0 0 0 6.5 1m0 9.207a.5.5 0 0 1-.5-.5V5.96a.5.5 0 0 1 1 0v3.747a.5.5 0 0 1-.5.5M6.146 4.06A.5.5 0 0 0 7 3.707v-.414a.5.5 0 0 0-1 0v.414a.5.5 0 0 0 .146.353",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgInfo);
export default ForwardRef;